import Box from '@mui/material/Box';
import { Form, useTranslate } from 'react-admin';
import TextInputWithLabels from '@/components/common/forms/common/text-input-with-labels/text-input-with-labels';
import ImageInputWithLabelOnTop from '@/components/common/forms/common/image-input-with-label-on-top/image-input-with-label-on-top';

const formId = '_form_maintenance_traitement_couche_protection_fort_trafic_1';

interface Props {
    readOnly?: boolean;
    defaultValues?: (formId: string) => {};
}

const HighTrafficProtectionLayerForm = ({ readOnly = false, defaultValues = (_formId: string): any => {} }: Props) => {
    const translate = useTranslate();

    return (
        <Form defaultValues={defaultValues(formId)}>
            <Box
                sx={{
                    display: 'grid',
                    gap: 2,
                }}
            >
                <TextInputWithLabels
                    topLabel={translate('forms.surface')}
                    rightLabel={translate('forms.m2_label')}
                    source='SurfaceM2'
                    readOnly={readOnly}
                />

                <TextInputWithLabels
                    topLabel={translate('forms.localization_label')}
                    source='Localisation'
                    readOnly={readOnly}
                />

                <ImageInputWithLabelOnTop label={translate('forms.image_label')} source='media' readOnly={readOnly} />
            </Box>
        </Form>
    );
};

export default HighTrafficProtectionLayerForm;
